import {observable, action} from 'mobx';
import {api, t} from 'shared/core';
import {endpoints} from 'main/tools';
import {successAlert, redirect} from 'shared/tools';

class ConfirmationCodeFormState {
  @observable confirmationCode;
  @observable errors = {};

  @action updateConfirmationCode(value) {
    this.confirmationCode = value;
  }

  @action async submitConfirmationCode() {
    this.errors = {};

    try {
      await api.post(endpoints.USER_ACTIVATIONS.ACTIVATE_USER, {confirmation_code: this.confirmationCode});
      await redirect('/');
    } catch (error) {
      this.errors = error.formErrors || {};
    }
  }

  @action async resendActivationEmail() {
    await api.post(endpoints.COMPANY_ONBOARD.RESEND_ACTIVATION_EMAIL);
    successAlert(t('company_onboard.Email confirmation sent.'));
  }
}

export default ConfirmationCodeFormState;
